import TeamList from '../components/team/TeamList';

const TeamManagementPage = () => <TeamList />;

export default TeamManagementPage;
